export default () => ({
  subscriptionModalOpen: false,
  _subscriptionOpener: null,

  openSubscription(variantId) {
    const updateVariantId = document.querySelector("[data-backin-stock-variant-id]")
    if (updateVariantId) updateVariantId.setAttribute("data-backin-stock-variant-id", variantId)
    this._subscriptionOpener = document.activeElement
    this.subscriptionModalOpen = true
  },
  closeSubscription() {
    const updatevariant = document.querySelector("[data-backin-stock-variant-id]")
    if (updatevariant) updatevariant.removeAttribute("data-backin-stock-variant-id")
    this.subscriptionModalOpen = false
    const opener = this._subscriptionOpener
    this._subscriptionOpener = null
    if (opener && typeof opener.focus === 'function') {
      queueMicrotask(() => opener.focus())
    }
  }
})
